var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v(" "+_vm._s(_vm.sub_msg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }